const scrollTo = target => {
  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest',
  })
}

module.exports = scrollTo